import React, { useRef, Fragment, useState, useEffect } from "react";
import html2pdf from "html2pdf.js";
import style from "../../styles/pdf.module.scss";
import { Link, useParams } from "react-router-dom";
import { obtenerDetalleFactura } from "../../api/Factura";
import LoaderComponent from "../../components/LoaderComponent";
import TitleH2Component from "../../components/TitleH2Component";
import stylebtn from "../../styles/btn.module.scss";
import ParrafoComponent from "../../components/ParrafoComponent";
import { useFormatter } from "../../hooks/useFormatter";
import { useFechaActual } from "../../hooks/useFechaActual";
const GenerarfacturaPages = () => {
  const [pdfUrl, setPdfUrl] = useState(null);
  const contentRefs = useRef([]);
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [currentCliente, setCurrentCliente] = useState([]);
  const [currentFactura, setCurrentFactura] = useState([]);
  const [currentFacturaDF, setCurrentFacturaDF] = useState([]);
 const { formatDate, formatDateUTC } = useFormatter();
  const { calcularDiferenciaDias } = useFechaActual();
  const fetchFactura = async () => {
    setLoading(true);
    try {
      const factura = await obtenerDetalleFactura(id);
      setCurrentFactura(factura?.data);
      setCurrentCliente(factura?.data?.Cliente?.Persona);
      /*const formattedData = (factura?.data?.DetalleFacturas || []).map((item) => ({
                    ...item,
    
                    formattedDate: new Date(item.createdAt).toLocaleDateString(), // Formatea la fecha sin usar hook
                }));*/
      const mergedProducts = (factura?.data?.DetalleFacturas || []).reduce(
        (acc, current) => {
          // Buscar si ya existe un producto con la misma clase, tipo y dimensión
          const existingProduct = acc.find(
            (item) =>
              item?.Producto?.Clase?.name === current.Producto.Clase?.name &&
              item?.Producto?.Tipo?.name === current.Producto.Tipo?.name &&
              item?.Producto?.dimension === current?.Producto?.dimension
          );

          if (existingProduct) {
            // Si existe, sumamos la cantidad y recalculamos el precio total
            existingProduct.cantidad += current.cantidad;
            existingProduct.pendientePorEntregar += current.pendientePorEntregar;
            existingProduct.valorTotalPorProducto =
              Number(existingProduct.valorTotalPorProducto) +
              Number(current.valorTotalPorProducto);
          } else {
            // Si no existe, lo añadimos al array acumulador
            acc.push({ ...current });
          }

          return acc;
        },
        []
      );

      const partitionArray = (array, size) => {
        const partitioned = [];
        for (let i = 0; i < array.length; i += size) {
          partitioned.push(array.slice(i, i + size));
        }
        return partitioned;
      };

      const partitionedProducts = partitionArray(mergedProducts, 7);
      setCurrentFacturaDF(partitionedProducts);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchCotizacion = async () => {
    setLoading(true);
    try {
      const facturadetalle =
        (await JSON.parse(localStorage.getItem("cotizacion"))) || [];
      const cliente = (await JSON.parse(localStorage.getItem("cliente"))) || [];
      const factura = (await JSON.parse(localStorage.getItem("factura"))) || [];
      setCurrentFactura(factura);
      setCurrentCliente(cliente);
      const mergedProducts = (facturadetalle || []).reduce((acc, current) => {
        // Buscar si ya existe un producto con la misma clase, tipo y dimensión
        const existingProduct = acc.find(
          (item) =>
            item?.clase === current.clase &&
            item?.tipo === current.tipo &&
            item?.dimension === current?.dimension
        );

        if (existingProduct) {
          // Si existe, sumamos la cantidad y recalculamos el precio total
          existingProduct.cantidad += current.cantidad;
          existingProduct.cantidadporentragar += current.cantidadporentragar;
          existingProduct.valorTotalPorProducto =
            Number(existingProduct.valorTotalPorProducto) +
            Number(current.valorTotalPorProducto);
        } else {
          // Si no existe, lo añadimos al array acumulador
          acc.push({ ...current });
        }

        return acc;
      }, []);

      const partitionArray = (array, size) => {
        const partitioned = [];
        for (let i = 0; i < array.length; i += size) {
          partitioned.push(array.slice(i, i + size));
        }
        return partitioned;
      };

      const partitionedProducts = partitionArray(mergedProducts, 7);
      setCurrentFacturaDF(partitionedProducts);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchFactura();
    } else {
      fetchCotizacion();
    }
  }, [id]);

  const handleGeneratePdf = () => {
    // Crear un div temporal para combinar todo el contenido
    const element = document.createElement("div");
    contentRefs.current.forEach((ref) => {
      if (ref) {
        element.appendChild(ref.cloneNode(true)); // Clona y agrega cada ref al div temporal
      }
    });

    // Generar el PDF y convertirlo a Blob
    html2pdf()
      .from(element)
      .toPdf()
      .output("blob")
      .then((pdfBlob) => {
        // Crear una URL para mostrar el PDF
        const url = URL.createObjectURL(pdfBlob);
        setPdfUrl(url);
      });
  };

  useEffect(() => {
    if (currentFacturaDF.length > 0) {
      setTimeout(() => {
        handleGeneratePdf();
      }, 500);
    }
  }, [currentFacturaDF]);


  const totalAbonos = currentFactura?.Abonos?.reduce(
    (acc, venta) => acc + Number(venta?.monto ?? 0),
    0
  );
 

  return (
    <Fragment>
      {loading ? (
        <LoaderComponent styleGroup="mt-5" />
      ) : (
        <div>
          {currentFacturaDF.map((group, index) => {
            return (
              <div
                ref={(el) => (contentRefs.current[index] = el)}
                className={`${index > 0 ? `${style.nuevapagina}` : ""} ${style.container_pdf
                  } `}
                key={index}
              >
                <TitleH2Component styleGroup=" color-dark fw700 roboto mb-2 text-center">
                  COMPRAVENTA DE MADERAS EL PACA
                </TitleH2Component>
                <ParrafoComponent styleGroup=" color-dark fw700 roboto mb-2 text-center">
                  NIT. 11.172.739-1
                </ParrafoComponent>
                <ParrafoComponent styleGroup=" color-dark fw700 roboto mb-2 text-center">
                  Compra y venta de toda clase de maderas: maderas elaboradas,
                  machimbre, tablas, listones y tablillas para piso.
                </ParrafoComponent>

                <div className="d-flex align-items-start justify-content-between fw700">
                  <div>
                    FECHA DE FACTURA
                    <div className={style.caja_fecha}>
                       {formatDate(currentFactura?.createdAt)}
                    </div>

                     {currentFactura?.fechaDePago && (
                      <div className="mt-2">
                        FECHA DE VENCIMIENTO
                        <div className={`${style.caja_fecha}`}>
                          {formatDateUTC(currentFactura?.fechaDePago)}
                        </div>
                        {/* Calcular y mostrar el plazo */}
                        <p>
                          Plazo:{calcularDiferenciaDias(currentFactura?.fechaDePago) > 0 ? ` ${calcularDiferenciaDias(currentFactura?.fechaDePago)} dias` : ' Vencida'}

                        </p>
                      </div>
                    )}
                  </div>


                  <div className="text-center">
                    Cra 5 No. 27-07 <br /> Barrio San Roque <br /> Moñitos
                    Córdoba <br /> 3012222358
                  </div>

                  <div>
                    FACTURA DE VENTA
                    <div className={style.caja_fecha}>
                      N° {currentFactura?.numeroFactura}
                    </div>
                  </div>
                </div>
                <div className={`${style.card_cliente}`}>
                  <div className={`${style.card_documento}`}>
                    <p>N Documento: {currentCliente?.cedula}</p>
                    <div className={`${style.linea}`}></div>
                    <p>
                      Cilente: {currentCliente?.nombre}{" "}
                      {currentCliente?.apellido}
                    </p>
                  </div>
                  <div className={`${style.card_direccion}`}>
                    <p>Direccion: {currentFactura?.direccion || currentCliente?.direccion}</p>
                  </div>
                  <div className={`${style.card_celular}`}>
                    <p>Celular: {currentCliente?.celular}</p>
                  </div>
                </div>

                  {currentFactura.nombre_conductor && currentFactura?.nombre_conductor !=="null" && (
                  <div className={`${style.card_cliente}`}>
                    <div className={`${style.card_documento_center}`}>
                      <p>Transportador: {currentFactura?.nombre_conductor}</p>
                      <div className={`${style.linea}`}></div>
                      <p>Celular: {currentFactura?.celular_conductor}</p>
                    </div>
                  </div>
                )}
                <table className={`${style.styled_table}`}>
                  <thead>
                    <tr>
                      <th colSpan={currentFactura?.tipo === "venta" ? 1 : 2}>CANT.</th>
                      <th colSpan={currentFactura?.tipo === "venta" ? 1 : 2}>DESCRIPCIÓN</th>
                      {currentFactura?.tipo ==='venta' && <th>ENTREGADOS</th>}
                     { currentFactura?.tipo ==='venta' && <th>PENDIENTE</th>}
                      <th>VAL. UNID</th>
                      <th>VAL. TOTAL</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.isArray(group) && group.length > 0 ? (
                      group.map((item, index) => (
                        <tr key={index}>
                          <td colSpan={currentFactura?.tipo === "venta" ? 1 : 2} className={`${style.empty_row}`}>
                            {" "}
                            {Number(item?.pendientePorEntregar) +
                              Number(item?.cantidad)}
                          </td>
                          <td colSpan={currentFactura?.tipo === "venta" ? 1 : 2} className={`${style.empty_row}`}>
                            {item?.Producto?.Tipo?.name ?? item?.tipo} de{" "}
                            {item?.Producto?.Clase?.name ?? item?.clase} de{" "}
                            {item?.Producto?.dimension ?? item?.dimension}
                          </td>
                          {currentFactura?.tipo==='venta' && <td className={`${style.empty_row}`}>
                            {item?.cantidad}
                          </td>}
                          {currentFactura?.tipo==='venta' && <td className={`${style.empty_row}`}>
                            {currentFactura?.tipo === 'venta' ? item?.pendientePorEntregar : 0}
                          </td>}

                          <td className={`${style.empty_row}`}>
                            {Number(
                              item?.Producto?.precioVenta ??
                              item?.valorPorUnidad
                            ).toLocaleString("es-ES")}
                          </td>
                          <td className={`${style.empty_row}`}>
                            {Number(item?.valorTotalPorProducto).toLocaleString(
                              "es-ES"
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={6} className={`${style.empty_row}`}>
                          No hay facturas disponibles
                        </td>
                      </tr>
                    )}
                  </tbody>
                  {Array.isArray(group) && group.length > 0 && (
                    <tfoot>

                      {currentFactura?.transporte && currentFactura?.transporte > 0 && <tr>
                        <td colSpan="1" className={currentFactura?.tipo === "cotizacion" ? style.notBorderR : ""}></td>
                        <td colSpan="1" className={currentFactura?.tipo === "cotizacion" ? style.notBorderL : ""}></td>
                        <td colSpan="1" className={currentFactura?.tipo === "cotizacion" ? style.notBorderR : ""}></td>
                        <td colSpan="1" className={currentFactura?.tipo === "cotizacion" ? style.notBorderL : ""}></td>
                        <td colSpan="1">Transporte</td>
                        <td>
                          $
                          {Number(
                            currentFactura?.transporte ?? 0
                          ).toLocaleString("es-ES")}
                        </td>
                      </tr>}


                      <tr>
                        <td colSpan="1"className={currentFactura?.tipo === "cotizacion" ? style.notBorderR : ""}></td>
                        <td colSpan="1" className={currentFactura?.tipo === "cotizacion" ? style.notBorderL : ""}></td>
                        <td colSpan="1">
                          <div className={`${style.cello}`}>
                            {currentFactura?.estado == 1 && currentFactura?.tipo === 'venta' && "NO PAGA"}
                            {currentFactura?.estado == 2 && currentFactura?.tipo === 'venta' && "PENDIENTE"}
                            {currentFactura?.estado == 0 && currentFactura?.tipo === 'venta' && "PAGA"}
                            {currentFactura?.estado !== 0 &&
                              currentFactura?.estado !== 1 &&
                              currentFactura?.estado === 2 &&
                              currentFactura?.tipo === 'cotizacion' &&
                              "COTIZACION"}
                          </div>
                        </td>
                        <td colSpan="1" className={currentFactura?.tipo === "cotizacion" ? style.notBorderL : ""}></td>
                        <td colSpan="1" >Subtotal</td>
                        <td>
                          $
                          {( Number(currentFactura?.subtotal) + Number(currentFactura?.transporte)).toLocaleString(
                            "es-ES"
                          )}

                        </td>
                      </tr>

                      {currentFactura?.tipo==='venta' && <tr>
                        <td colSpan="1" className={currentFactura?.tipo === "cotizacion" ? style.notBorderR : ""}></td>
                        <td colSpan="1" className={currentFactura?.tipo === "cotizacion" ? style.notBorderL : ""}></td>
                        <td colSpan="1" className={currentFactura?.tipo === "cotizacion" ? style.notBorderR : ""}></td>
                        <td colSpan="1" className={currentFactura?.tipo === "cotizacion" ? style.notBorderL : ""}></td>
                        <td colSpan="1">Abono</td>
                        <td>
                          $
                          {Number(
                            totalAbonos
                          ).toLocaleString("es-ES")}
                        </td>
                      </tr>}



                      {currentFactura?.descuento && currentFactura?.descuento > 0 && (
                        <tr>
                          <td colSpan="1" className={currentFactura?.tipo === "cotizacion" ? style.notBorderR : ""}></td>
                          <td colSpan="1" className={currentFactura?.tipo === "cotizacion" ? style.notBorderL : ""}></td>
                          <td colSpan="1" className={currentFactura?.tipo === "cotizacion" ? style.notBorderR : ""}></td>
                          <td colSpan="1" className={currentFactura?.tipo === "cotizacion" ? style.notBorderL : ""}></td>
                          <td colSpan="1">Descuento</td>
                          <td>
                            $
                            {Number(currentFactura?.descuento).toLocaleString(
                              "es-ES"
                            )}
                          </td>
                        </tr>
                      )}
                      {currentFactura?.tipo === 'venta' && <tr>
                        <td colSpan="1"></td>
                        <td colSpan="1"></td>
                        <td colSpan="1"></td>
                        <td colSpan="1"></td>
                        <td colSpan="1" className="text-nowrap">Pend. Pago</td>
                        <td className="bg-success bg-opacity-75 text-white fw-bold">
                          $
                          {Number(currentFactura?.financiado) === 0 ? 0 : (Number(currentFactura?.total) + Number(currentFactura?.transporte) - totalAbonos - currentFactura?.descuento).toLocaleString(
                            "es-ES"
                          )}
                        </td>
                      </tr>}


                      { /*<tr>
                        <td colSpan="1"></td>
                        <td colSpan="1"></td>
                        <td colSpan="1"></td>
                        <td colSpan="1"></td>
                        <td colSpan="1">Total</td>
                        <td>
                          $
                          {Number(
                            Number(currentFactura?.total ?? 0) +
                              Number(currentFactura?.transporte ?? 0)
                          ).toLocaleString("es-ES")}
                        </td>
                      </tr>*/}
                    </tfoot>
                  )}
                </table>
                <div className={`d-flex align-items-center ${currentFactura?.quien_recibe ? 'justify-content-between' : 'justify-content-end'}`}>
                  {currentFactura?.quien_recibe && <ParrafoComponent styleGroup={`${style.firma} box-text fw700 color-darkroboto mb-1 mt-2`}>
                    Quien recibe: {currentFactura?.quien_recibe}
                  </ParrafoComponent>}

                  <ParrafoComponent styleGroup={`${style.firma}  box-text fw700 color-darkroboto mb-1 mt-2`}>
                    Vendedor: {currentFactura?.User?.nombre}
                  </ParrafoComponent>
                </div>
              </div>
            );
          })}

          {pdfUrl ? (
            <div className={`${style.viewpdf}`}>
              <embed
                src={pdfUrl}
                type="application/pdf"
                width="100%"
                height="600px"
                style={{ border: "1px solid black" }}
              />
              <Link
                to={currentFactura?.tipo === 'venta' ? "/factura" : '/ver_cotizaciones'}
                className={`${style.btn_volver} ${stylebtn.btn} ${stylebtn.primary}`}
              >
                Ir a {currentFactura?.tipo === 'venta' ? 'Facturas' : 'Cotizaciones'}
              </Link>
            </div>
          ) : (
            <LoaderComponent styleGroup="mt-5" />
          )}
        </div>
      )}
    </Fragment>
  );
};
export default GenerarfacturaPages;
